import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogChangeEmailComponent } from "src/app/dashboard/profile/dialog-change-email/dialog-change-email.component";
import { DialogChangePhoneComponent } from "src/app/dashboard/profile/dialog-change-phone/dialog-change-phone.component";
import { DialogReauthPasswordComponent } from "src/app/dashboard/profile/dialog-reauth-password/dialog-reauth-password.component";
import { UpdateNameDialogComponent } from "src/app/dashboard/saving-plans/saving-plan/update-name-dialog/update-name-dialog.component";
import { ProductDialogComponent } from "src/app/dashboard/shop/product-dialog/product-dialog.component";
import { DialogImage } from "src/app/data/dialog-image";
import { DialogAlertComponent } from "src/app/shared/dialog-alert/dialog-alert.component";
import { DialogSmsComponent } from "src/app/shared/dialog-sms/dialog-sms.component";
import { DialogYesNoComponent } from "src/app/shared/dialog-yes-no/dialog-yes-no.component";
import { TermsAndConditionsComponent } from "src/app/shared/terms-and-conditions/terms-and-conditions.component";
import { UserAgreementComponent } from "src/app/shared/user-agreement/user-agreement.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  showSuccessDialog(text: string, dialogImage?: DialogImage) {
    return this.openDialog(DialogAlertComponent, {
      text,
      dialogImage,
      translatable:true,
      success: true,
    });
  }

  showErrorDialog(text: string, dialogImage?: DialogImage, translatable?:boolean) {
    return this.openDialog(DialogAlertComponent, {
      text,
      dialogImage,
      translatable:translatable||true,
      success: false,
    });
  }

  showProductDialog(product) {
    this.matDialog.closeAll();
    return this.openDialog(ProductDialogComponent, product);
  }

  showYesNoDialog(text: string) {
    return this.openDialog(DialogYesNoComponent, text);
  }

  showSmsDialog() {
    return this.openDialog(DialogSmsComponent, null);
  }

  showChangeEmailDialog() {
    return this.openDialog(DialogChangeEmailComponent, null);
  }

  showReauthPassDialog() {
    return this.openDialog(DialogReauthPasswordComponent, null);
  }

  showChangePhoneDialog() {
    return this.openDialog(DialogChangePhoneComponent, null);
  }

  showUpdateNameDialog() {
    return this.openDialog(UpdateNameDialogComponent, null);
  }

  showUserAgreement() {
    return this.openDialog(UserAgreementComponent, null);
  }

  showTermsAndConditions(){
    return this.openDialog(TermsAndConditionsComponent, null)
  }

  showExcessiveAmountDialog(){
    return this.openDialog(DialogAlertComponent, {excessiveAmount :true, text:"SAVING_PLAN_EXCESSIVE_AMOUNT", translatable:true})
  }

  showOneMoreCheckoutDialog(){
    return this.openDialog(DialogAlertComponent, {text:"NEEDED_CHECKOUT", translatable: true});
  }
  showOneMoreSubscriptionDialog(){
    return this.openDialog(DialogAlertComponent, {text:"NEEDED_SUBSCRIPTION", translatable: true});
  }

  openDialog(component, data) {
    return this.matDialog
      .open(component, {
        data: data,
        panelClass: "dialog-background",
        minWidth: "400px",
      })
      .afterClosed();
  }
}
